import type { FC, ReactNode } from "react"
import React, { useRef } from "react"
import classNames from "classnames"
import "./index.scss"
// ==============================================
interface PopoverVO {
  children?: any
  content: ReactNode
  visible: boolean // 显隐
  className?: string
}
const Popover: FC<PopoverVO> = ({ className, children, content, visible }) => {
  const childrenBoxRef = useRef<any>()
  const offsetLeft = childrenBoxRef.current?.offsetLeft || 0
  // let offsetWidth = childrenBoxRef.current?.offsetWidth || 0
  // let left = offsetLeft && offsetWidth ? offsetLeft - 15 + offsetWidth / 2 : 0
  return (
    <div className={classNames("customize-popover", className)}>
      {/* box */}
      <div
        className="popover-content-box"
        style={{
          display: visible ? "inline-block" : "none",
        }}
      >
        <div
          className="popover-arrow"
          style={{
            left: offsetLeft,
          }}
        />
        <div className="popover-content">{content}</div>
      </div>
      {/* children */}
      <div ref={childrenBoxRef} className="popover-children-box">
        {children}
      </div>
    </div>
  )
}

export default Popover
